import { SALESFORCE_DATA_SOURCE_TYPE } from '@/constants/data_sources';
import {
  CLOUDFLARE_SALESFORCE_PROXY,
  FEATURE_FLAG,
  MULTI_SELECT_SF,
} from '@/constants/feature_flags';
import { useFeatureFlagStore } from '@/stores';
import type { Feed } from '@/types/feeds';
import type { DataSourceType } from '@/types/sources';

type ProxiedFeedType =
  | Pick<Feed, 'integration' | 'custom_base_url'>
  | null
  | undefined;

export default function useSalesforceProxyGate() {
  const { hasFeatureFlag } = useFeatureFlagStore();

  function isProxyUrlApplicable(
    integrationType: DataSourceType | null,
  ): boolean {
    return (
      integrationType === SALESFORCE_DATA_SOURCE_TYPE &&
      hasFeatureFlag(CLOUDFLARE_SALESFORCE_PROXY) &&
      !hasFeatureFlag(MULTI_SELECT_SF) &&
      /* The JWT flow bypasses the proxy, so the authorize endpoint refuses a
         base_url for it. */
      !hasFeatureFlag(FEATURE_FLAG.TEMP_SFDC_JWT_FIELDS)
    );
  }

  function hasStoredProxyUrl(feed: ProxiedFeedType): boolean {
    return Boolean(feed?.custom_base_url);
  }

  /* A stored URL stays editable whatever the flags say, so it can always be
     removed. */
  function canEditProxyUrl(feed: ProxiedFeedType): boolean {
    return (
      isProxyUrlApplicable(feed?.integration?.type ?? null) ||
      hasStoredProxyUrl(feed)
    );
  }

  return { isProxyUrlApplicable, hasStoredProxyUrl, canEditProxyUrl };
}
